import { BASE_URL } from '../../../../../utils/config.base-url'

export const TASK_FILE_CATEGORY_PREFIX_URL = '/task-file-category'
export const URL_ENDPOINT_TASK_FILE_CATEGORY = `${BASE_URL}/task-file-category`
